import React from 'react';
import titleImg from '../../../asset/img/housingfunds_title_img.svg';
import Typography from '../../../components/common/Typography';
import { useTranslation } from 'react-i18next';

const EmptyHousingFund = () => {
  const { t } = useTranslation('deductions/housingFunds');
  return (
    <div
      className="displayFlexColumn"
      style={{ alignItems: 'center', flex: 1, justifyContent: 'center', gap: '20px' }}>
      <img src={titleImg} />
      <div className="displayFlexColumn" style={{ alignItems: 'center', gap: '8px' }}>
        <Typography className="body1Bold">{t('emptyHousingFund.title')}</Typography>
        <Typography className="body2Medium">{t('emptyHousingFund.description')}</Typography>
      </div>
    </div>
  );
};

export default EmptyHousingFund;
